/**
 * AUTO-GENERATED — node scripts/buildGnkBudgetSubjectSeed.js
 * GNK 예산과목 flat 행 (246건)
 * levels: {"관":8,"세항":21,"항":2,"목":84,"세목":131}
 */
export const GNK_BUDGET_SUBJECT_ROWS = [
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "관",
    "parentCode": "",
    "subjectCode": "10000",
    "subjectName": "사무비",
    "abbrName": "사무비",
    "finalYn": "N",
    "sortOrder": 10
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세항",
    "parentCode": "10000",
    "subjectCode": "10100",
    "subjectName": "인건비",
    "abbrName": "인건비",
    "finalYn": "N",
    "sortOrder": 20
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세항",
    "parentCode": "10000",
    "subjectCode": "10200",
    "subjectName": "원장인건비",
    "abbrName": "원장인건비",
    "finalYn": "N",
    "sortOrder": 30
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세항",
    "parentCode": "10000",
    "subjectCode": "10300",
    "subjectName": "보육교직원인건비",
    "abbrName": "보육교직원인건비",
    "finalYn": "N",
    "sortOrder": 40
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세항",
    "parentCode": "10000",
    "subjectCode": "10400",
    "subjectName": "기타인건비",
    "abbrName": "기타인건비",
    "finalYn": "N",
    "sortOrder": 50
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세항",
    "parentCode": "10000",
    "subjectCode": "10700",
    "subjectName": "운영비",
    "abbrName": "운영비",
    "finalYn": "N",
    "sortOrder": 60
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세항",
    "parentCode": "10000",
    "subjectCode": "10500",
    "subjectName": "기관부담금",
    "abbrName": "기관부담금",
    "finalYn": "N",
    "sortOrder": 70
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세항",
    "parentCode": "10000",
    "subjectCode": "10600",
    "subjectName": "업무추진비",
    "abbrName": "업무추진비",
    "finalYn": "N",
    "sortOrder": 80
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "관",
    "parentCode": "",
    "subjectCode": "20000",
    "subjectName": "재산조성비",
    "abbrName": "재산조성비",
    "finalYn": "N",
    "sortOrder": 90
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세항",
    "parentCode": "20000",
    "subjectCode": "20100",
    "subjectName": "시설비",
    "abbrName": "시설비",
    "finalYn": "N",
    "sortOrder": 100
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "관",
    "parentCode": "",
    "subjectCode": "30000",
    "subjectName": "사업비",
    "abbrName": "사업비",
    "finalYn": "N",
    "sortOrder": 110
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세항",
    "parentCode": "30000",
    "subjectCode": "30100",
    "subjectName": "조사연구사업",
    "abbrName": "조사연구사업",
    "finalYn": "N",
    "sortOrder": 120
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세항",
    "parentCode": "30000",
    "subjectCode": "30500",
    "subjectName": "사업비",
    "abbrName": "사업비",
    "finalYn": "N",
    "sortOrder": 130
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "항",
    "parentCode": "30000",
    "subjectCode": "30600",
    "subjectName": "운영비(시설)",
    "abbrName": "운영비(시설)",
    "finalYn": "N",
    "sortOrder": 140
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세항",
    "parentCode": "30600",
    "subjectCode": "30601",
    "subjectName": "운영비(시설)",
    "abbrName": "운영비(시설)",
    "finalYn": "N",
    "sortOrder": 150
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세항",
    "parentCode": "30000",
    "subjectCode": "30200",
    "subjectName": "교육비",
    "abbrName": "교육비",
    "finalYn": "N",
    "sortOrder": 160
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세항",
    "parentCode": "30000",
    "subjectCode": "30300",
    "subjectName": "기본보육활동",
    "abbrName": "기본보육활동",
    "finalYn": "N",
    "sortOrder": 170
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세항",
    "parentCode": "30000",
    "subjectCode": "30400",
    "subjectName": "수익자부담경비",
    "abbrName": "수익자부담경비",
    "finalYn": "N",
    "sortOrder": 180
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "관",
    "parentCode": "",
    "subjectCode": "70000",
    "subjectName": "잡지출",
    "abbrName": "잡지출",
    "finalYn": "N",
    "sortOrder": 190
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세항",
    "parentCode": "70000",
    "subjectCode": "70100",
    "subjectName": "잡지출",
    "abbrName": "잡지출",
    "finalYn": "N",
    "sortOrder": 200
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "관",
    "parentCode": "",
    "subjectCode": "40000",
    "subjectName": "전출금",
    "abbrName": "전출금",
    "finalYn": "N",
    "sortOrder": 210
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세항",
    "parentCode": "40000",
    "subjectCode": "40100",
    "subjectName": "전출금",
    "abbrName": "전출금",
    "finalYn": "N",
    "sortOrder": 220
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "관",
    "parentCode": "",
    "subjectCode": "50000",
    "subjectName": "과년도지출",
    "abbrName": "과년도지출",
    "finalYn": "N",
    "sortOrder": 230
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세항",
    "parentCode": "50000",
    "subjectCode": "50100",
    "subjectName": "과년도지출",
    "abbrName": "과년도지출",
    "finalYn": "N",
    "sortOrder": 240
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "관",
    "parentCode": "",
    "subjectCode": "60000",
    "subjectName": "상환금",
    "abbrName": "상환금",
    "finalYn": "N",
    "sortOrder": 250
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세항",
    "parentCode": "60000",
    "subjectCode": "60100",
    "subjectName": "상환금",
    "abbrName": "상환금",
    "finalYn": "N",
    "sortOrder": 260
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "항",
    "parentCode": "60000",
    "subjectCode": "60200",
    "subjectName": "부채상환금",
    "abbrName": "부채상환금",
    "finalYn": "N",
    "sortOrder": 270
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세항",
    "parentCode": "60200",
    "subjectCode": "60201",
    "subjectName": "부채상환금",
    "abbrName": "부채상환금",
    "finalYn": "N",
    "sortOrder": 280
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "관",
    "parentCode": "",
    "subjectCode": "80000",
    "subjectName": "예비비 및 기타",
    "abbrName": "예비비 및 기타",
    "finalYn": "N",
    "sortOrder": 290
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세항",
    "parentCode": "80000",
    "subjectCode": "80100",
    "subjectName": "예비비 및 기타",
    "abbrName": "예비비 및 기타",
    "finalYn": "N",
    "sortOrder": 300
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세항",
    "parentCode": "80000",
    "subjectCode": "80101",
    "subjectName": "반환금",
    "abbrName": "반환금",
    "finalYn": "N",
    "sortOrder": 310
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "목",
    "parentCode": "80100",
    "subjectCode": "80102",
    "subjectName": "반환금",
    "abbrName": "반환금",
    "finalYn": "N",
    "sortOrder": 320
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "80102",
    "subjectCode": "8010205",
    "subjectName": "반환금(당해년도)_기타 반환금",
    "abbrName": "반환금(당해년도",
    "finalYn": "Y",
    "sortOrder": 330
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "목",
    "parentCode": "30500",
    "subjectCode": "33108",
    "subjectName": "지속준비사업비(예산)",
    "abbrName": "지속준비사업비(",
    "finalYn": "N",
    "sortOrder": 340
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "33108",
    "subjectCode": "3310801",
    "subjectName": "지속준비사업비(예산)",
    "abbrName": "지속준비사업비(",
    "finalYn": "Y",
    "sortOrder": 350
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "목",
    "parentCode": "20100",
    "subjectCode": "20102",
    "subjectName": "자산취득비",
    "abbrName": "자산취득비",
    "finalYn": "N",
    "sortOrder": 360
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "20102",
    "subjectCode": "2010201",
    "subjectName": "자산취득비",
    "abbrName": "자산취득비",
    "finalYn": "Y",
    "sortOrder": 370
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "목",
    "parentCode": "20100",
    "subjectCode": "20103",
    "subjectName": "시설장비유지비",
    "abbrName": "시설장비유지비",
    "finalYn": "N",
    "sortOrder": 380
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "20103",
    "subjectCode": "2010301",
    "subjectName": "시설장비유지비",
    "abbrName": "시설장비유지비",
    "finalYn": "Y",
    "sortOrder": 390
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "목",
    "parentCode": "30500",
    "subjectCode": "30219",
    "subjectName": "가정보호 및 대안양육 (예산)",
    "abbrName": "가정보호 및 대",
    "finalYn": "N",
    "sortOrder": 400
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "30219",
    "subjectCode": "3021901",
    "subjectName": "가정보호 및 대안양육 (예산)",
    "abbrName": "가정보호 및 대",
    "finalYn": "Y",
    "sortOrder": 410
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "목",
    "parentCode": "30500",
    "subjectCode": "30408",
    "subjectName": "신체건강 지원 (예산)",
    "abbrName": "신체건강 지원 ",
    "finalYn": "N",
    "sortOrder": 420
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "30408",
    "subjectCode": "3040801",
    "subjectName": "신체건강 지원 (예산)",
    "abbrName": "신체건강 지원 ",
    "finalYn": "Y",
    "sortOrder": 430
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "목",
    "parentCode": "30500",
    "subjectCode": "10101",
    "subjectName": "급여",
    "abbrName": "급여",
    "finalYn": "N",
    "sortOrder": 440
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "10101",
    "subjectCode": "1010103",
    "subjectName": "급여(본부)",
    "abbrName": "급여(본부)",
    "finalYn": "Y",
    "sortOrder": 450
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "목",
    "parentCode": "10700",
    "subjectCode": "10702",
    "subjectName": "수용비및수수료",
    "abbrName": "수용비및수수료",
    "finalYn": "N",
    "sortOrder": 460
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "10702",
    "subjectCode": "1070202",
    "subjectName": "수용비및수수료",
    "abbrName": "수용비및수수료",
    "finalYn": "Y",
    "sortOrder": 470
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "목",
    "parentCode": "10100",
    "subjectCode": "10100-10101",
    "subjectName": "급여",
    "abbrName": "급여",
    "finalYn": "N",
    "sortOrder": 480
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "10100-10101",
    "subjectCode": "10100-1010103",
    "subjectName": "급여(본부)",
    "abbrName": "급여(본부)",
    "finalYn": "Y",
    "sortOrder": 490
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "목",
    "parentCode": "30500",
    "subjectCode": "33107",
    "subjectName": "조사연구사업(예산)",
    "abbrName": "조사연구사업(예",
    "finalYn": "N",
    "sortOrder": 500
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "33107",
    "subjectCode": "3310701",
    "subjectName": "조사연구사업(예산)",
    "abbrName": "조사연구사업(예",
    "finalYn": "Y",
    "sortOrder": 510
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "목",
    "parentCode": "30500",
    "subjectCode": "31107",
    "subjectName": "지역사회 지원(예산)",
    "abbrName": "지역사회 지원(",
    "finalYn": "N",
    "sortOrder": 520
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "31107",
    "subjectCode": "3110701",
    "subjectName": "지역사회 지원(예산)",
    "abbrName": "지역사회 지원(",
    "finalYn": "Y",
    "sortOrder": 530
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "목",
    "parentCode": "30500",
    "subjectCode": "31004",
    "subjectName": "아동권리 캠페인 (예산)",
    "abbrName": "아동권리 캠페인",
    "finalYn": "N",
    "sortOrder": 540
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "31004",
    "subjectCode": "3100401",
    "subjectName": "아동권리 캠페인 (예산)",
    "abbrName": "아동권리 캠페인",
    "finalYn": "Y",
    "sortOrder": 550
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "목",
    "parentCode": "30500",
    "subjectCode": "30803",
    "subjectName": "자립 지원(예산)",
    "abbrName": "자립 지원(예산",
    "finalYn": "N",
    "sortOrder": 560
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "30803",
    "subjectCode": "3080301",
    "subjectName": "자립 지원(예산)",
    "abbrName": "자립 지원(예산",
    "finalYn": "Y",
    "sortOrder": 570
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "목",
    "parentCode": "30500",
    "subjectCode": "30706",
    "subjectName": "미래성장 지원 (예산)",
    "abbrName": "미래성장 지원 ",
    "finalYn": "N",
    "sortOrder": 580
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "30706",
    "subjectCode": "3070601",
    "subjectName": "미래성장 지원 (예산)",
    "abbrName": "미래성장 지원 ",
    "finalYn": "Y",
    "sortOrder": 590
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "목",
    "parentCode": "30500",
    "subjectCode": "30604",
    "subjectName": "아동친화적 환경, 인프라 개선 기획사업(예산)",
    "abbrName": "아동친화적 환경",
    "finalYn": "N",
    "sortOrder": 600
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "30604",
    "subjectCode": "3060401",
    "subjectName": "아동친화적 환경, 인프라 개선 기획사업(예산)",
    "abbrName": "아동친화적 환경",
    "finalYn": "Y",
    "sortOrder": 610
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "목",
    "parentCode": "30500",
    "subjectCode": "30507",
    "subjectName": "마음건강 지원 (예산)",
    "abbrName": "마음건강 지원 ",
    "finalYn": "N",
    "sortOrder": 620
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "30507",
    "subjectCode": "3050701",
    "subjectName": "마음건강 지원 (예산)",
    "abbrName": "마음건강 지원 ",
    "finalYn": "Y",
    "sortOrder": 630
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "목",
    "parentCode": "30500",
    "subjectCode": "30303",
    "subjectName": "위기가정아동 긴급지원 (예산)",
    "abbrName": "위기가정아동 긴",
    "finalYn": "N",
    "sortOrder": 640
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "30303",
    "subjectCode": "3030301",
    "subjectName": "위기가정아동 긴급지원 (예산)",
    "abbrName": "위기가정아동 긴",
    "finalYn": "Y",
    "sortOrder": 650
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "목",
    "parentCode": "30500",
    "subjectCode": "30104",
    "subjectName": "학대피해아동보호 및 예방 (예산)",
    "abbrName": "학대피해아동보호",
    "finalYn": "N",
    "sortOrder": 660
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "30104",
    "subjectCode": "3010401",
    "subjectName": "학대피해아동보호 및 예방 (예산)",
    "abbrName": "학대피해아동보호",
    "finalYn": "Y",
    "sortOrder": 670
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "목",
    "parentCode": "30500",
    "subjectCode": "32301",
    "subjectName": "모금사업비",
    "abbrName": "모금사업비",
    "finalYn": "N",
    "sortOrder": 680
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "32301",
    "subjectCode": "3230110",
    "subjectName": "캠페인사업 지원인력",
    "abbrName": "캠페인사업 지원",
    "finalYn": "Y",
    "sortOrder": 690
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "32301",
    "subjectCode": "3230104",
    "subjectName": "국내신규회원관리",
    "abbrName": "국내신규회원관리",
    "finalYn": "Y",
    "sortOrder": 700
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "10101",
    "subjectCode": "1010101",
    "subjectName": "급여(정규직/기간제)",
    "abbrName": "급여(정규직/기",
    "finalYn": "Y",
    "sortOrder": 710
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "목",
    "parentCode": "30500",
    "subjectCode": "31002",
    "subjectName": "아동권리옹호활동",
    "abbrName": "아동권리옹호활동",
    "finalYn": "N",
    "sortOrder": 720
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "31002",
    "subjectCode": "3100202",
    "subjectName": "홍보 및 캠페인",
    "abbrName": "홍보 및 캠페인",
    "finalYn": "Y",
    "sortOrder": 730
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "32301",
    "subjectCode": "3230105",
    "subjectName": "국내기존회원관리",
    "abbrName": "국내기존회원관리",
    "finalYn": "Y",
    "sortOrder": 740
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "32301",
    "subjectCode": "3230109",
    "subjectName": "회원특성별관리",
    "abbrName": "회원특성별관리",
    "finalYn": "Y",
    "sortOrder": 750
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "32301",
    "subjectCode": "3230107",
    "subjectName": "컨텐츠 제작",
    "abbrName": "컨텐츠 제작",
    "finalYn": "Y",
    "sortOrder": 760
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "32301",
    "subjectCode": "3230106",
    "subjectName": "보고서 제작",
    "abbrName": "보고서 제작",
    "finalYn": "Y",
    "sortOrder": 770
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "32301",
    "subjectCode": "3230101",
    "subjectName": "모금관리비",
    "abbrName": "모금관리비",
    "finalYn": "Y",
    "sortOrder": 780
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "목",
    "parentCode": "10700",
    "subjectCode": "10703",
    "subjectName": "지급수수료",
    "abbrName": "지급수수료",
    "finalYn": "N",
    "sortOrder": 790
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "10703",
    "subjectCode": "1070301",
    "subjectName": "지급수수료(본부)",
    "abbrName": "지급수수료(본부",
    "finalYn": "Y",
    "sortOrder": 800
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "목",
    "parentCode": "30500",
    "subjectCode": "33102",
    "subjectName": "부서운영비",
    "abbrName": "부서운영비",
    "finalYn": "N",
    "sortOrder": 810
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "33102",
    "subjectCode": "3310201",
    "subjectName": "부서운영비",
    "abbrName": "부서운영비",
    "finalYn": "Y",
    "sortOrder": 820
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "목",
    "parentCode": "30500",
    "subjectCode": "30801",
    "subjectName": "자립역량 지원",
    "abbrName": "자립역량 지원",
    "finalYn": "N",
    "sortOrder": 830
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "30801",
    "subjectCode": "3080101",
    "subjectName": "자립준비",
    "abbrName": "자립준비",
    "finalYn": "Y",
    "sortOrder": 840
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "목",
    "parentCode": "40100",
    "subjectCode": "40105",
    "subjectName": "지역아동센터 전출금(후원금)",
    "abbrName": "지역아동센터 전",
    "finalYn": "N",
    "sortOrder": 850
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "40105",
    "subjectCode": "4010502",
    "subjectName": "지역아동센터 전출금(후원금)기타",
    "abbrName": "지역아동센터 전",
    "finalYn": "Y",
    "sortOrder": 860
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "목",
    "parentCode": "10700",
    "subjectCode": "10714",
    "subjectName": "기타제지출",
    "abbrName": "기타제지출",
    "finalYn": "N",
    "sortOrder": 870
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "10714",
    "subjectCode": "1071401",
    "subjectName": "기타제지출",
    "abbrName": "기타제지출",
    "finalYn": "Y",
    "sortOrder": 880
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "목",
    "parentCode": "10700",
    "subjectCode": "10701",
    "subjectName": "여비",
    "abbrName": "여비",
    "finalYn": "N",
    "sortOrder": 890
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "10701",
    "subjectCode": "1070103",
    "subjectName": "감사수행여비",
    "abbrName": "감사수행여비",
    "finalYn": "Y",
    "sortOrder": 900
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "목",
    "parentCode": "10700",
    "subjectCode": "10705",
    "subjectName": "통신비",
    "abbrName": "통신비",
    "finalYn": "N",
    "sortOrder": 910
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "10705",
    "subjectCode": "1070501",
    "subjectName": "통신비(본부)",
    "abbrName": "통신비(본부)",
    "finalYn": "Y",
    "sortOrder": 920
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "목",
    "parentCode": "30500",
    "subjectCode": "30302",
    "subjectName": "위기가정아동 돌봄 및 지원 기획사업비",
    "abbrName": "위기가정아동 돌",
    "finalYn": "N",
    "sortOrder": 930
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "30302",
    "subjectCode": "3030201",
    "subjectName": "위기가정아동 돌봄 및 지원 기획사업",
    "abbrName": "위기가정아동 돌",
    "finalYn": "Y",
    "sortOrder": 940
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "목",
    "parentCode": "30500",
    "subjectCode": "32204",
    "subjectName": "대외협력사업(정책연구사업)",
    "abbrName": "대외협력사업(정",
    "finalYn": "N",
    "sortOrder": 950
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "32204",
    "subjectCode": "3220401",
    "subjectName": "대외협력사업비(정책연구사업)",
    "abbrName": "대외협력사업비(",
    "finalYn": "Y",
    "sortOrder": 960
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "33102",
    "subjectCode": "3310202",
    "subjectName": "업무추진비",
    "abbrName": "업무추진비",
    "finalYn": "Y",
    "sortOrder": 970
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "목",
    "parentCode": "30500",
    "subjectCode": "31106",
    "subjectName": "지역사회 지원 기획사업비",
    "abbrName": "지역사회 지원 ",
    "finalYn": "N",
    "sortOrder": 980
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "31106",
    "subjectCode": "3110601",
    "subjectName": "지역사회 지원 기획사업",
    "abbrName": "지역사회 지원 ",
    "finalYn": "Y",
    "sortOrder": 990
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "목",
    "parentCode": "30500",
    "subjectCode": "33101",
    "subjectName": "기획사업비",
    "abbrName": "기획사업비",
    "finalYn": "N",
    "sortOrder": 1000
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "33101",
    "subjectCode": "3310104",
    "subjectName": "교육및워크샵",
    "abbrName": "교육및워크샵",
    "finalYn": "Y",
    "sortOrder": 1010
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "목",
    "parentCode": "40100",
    "subjectCode": "40104",
    "subjectName": "심리치유센터 전출금(후원금)",
    "abbrName": "심리치유센터 전",
    "finalYn": "N",
    "sortOrder": 1020
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "40104",
    "subjectCode": "4010401",
    "subjectName": "심리치유센터 전출금(후원금)",
    "abbrName": "심리치유센터 전",
    "finalYn": "Y",
    "sortOrder": 1030
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "목",
    "parentCode": "40100",
    "subjectCode": "40112",
    "subjectName": "사회적약자통합지원센터 전출금(후원금)",
    "abbrName": "사회적약자통합지",
    "finalYn": "N",
    "sortOrder": 1040
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "40112",
    "subjectCode": "4011201",
    "subjectName": "사회적약자통합지원센터 전출금(후원금)",
    "abbrName": "사회적약자통합지",
    "finalYn": "Y",
    "sortOrder": 1050
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "목",
    "parentCode": "40100",
    "subjectCode": "40107",
    "subjectName": "종합사회복지관 전출금(후원금)",
    "abbrName": "종합사회복지관 ",
    "finalYn": "N",
    "sortOrder": 1060
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "40107",
    "subjectCode": "4010701",
    "subjectName": "종합사회복지관 전출금(후원금)",
    "abbrName": "종합사회복지관 ",
    "finalYn": "Y",
    "sortOrder": 1070
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "목",
    "parentCode": "40100",
    "subjectCode": "40110",
    "subjectName": "가정위탁지원센터 전출금(후원금)",
    "abbrName": "가정위탁지원센터",
    "finalYn": "N",
    "sortOrder": 1080
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "40110",
    "subjectCode": "4011001",
    "subjectName": "가정위탁지원센터 전출금(후원금)",
    "abbrName": "가정위탁지원센터",
    "finalYn": "Y",
    "sortOrder": 1090
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "목",
    "parentCode": "40100",
    "subjectCode": "40109",
    "subjectName": "아동복지센터 전출금(후원금)",
    "abbrName": "아동복지센터 전",
    "finalYn": "N",
    "sortOrder": 1100
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "40109",
    "subjectCode": "4010901",
    "subjectName": "아동복지센터 전출금(후원금)",
    "abbrName": "아동복지센터 전",
    "finalYn": "Y",
    "sortOrder": 1110
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "목",
    "parentCode": "40100",
    "subjectCode": "40108",
    "subjectName": "자립지원전담기관 전출금(후원금)",
    "abbrName": "자립지원전담기관",
    "finalYn": "N",
    "sortOrder": 1120
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "40108",
    "subjectCode": "4010801",
    "subjectName": "자립지원전담기관 전출금(후원금)",
    "abbrName": "자립지원전담기관",
    "finalYn": "Y",
    "sortOrder": 1130
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "목",
    "parentCode": "40100",
    "subjectCode": "40111",
    "subjectName": "지역아동센터 시도지원단 전출금(후원금)",
    "abbrName": "지역아동센터 시",
    "finalYn": "N",
    "sortOrder": 1140
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "40111",
    "subjectCode": "4011101",
    "subjectName": "지역아동센터 시도지원단 전출금(후원금)",
    "abbrName": "지역아동센터 시",
    "finalYn": "Y",
    "sortOrder": 1150
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "목",
    "parentCode": "30100",
    "subjectCode": "32102",
    "subjectName": "대외협력사업",
    "abbrName": "대외협력사업",
    "finalYn": "N",
    "sortOrder": 1160
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "32102",
    "subjectCode": "3210201",
    "subjectName": "대외협력사업비",
    "abbrName": "대외협력사업비",
    "finalYn": "Y",
    "sortOrder": 1170
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "33101",
    "subjectCode": "3310105",
    "subjectName": "기타지부지원사업비",
    "abbrName": "기타지부지원사업",
    "finalYn": "Y",
    "sortOrder": 1180
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "40112",
    "subjectCode": "4011202",
    "subjectName": "사회적약자통합지원센터 전출금(후원금)기타",
    "abbrName": "사회적약자통합지",
    "finalYn": "Y",
    "sortOrder": 1190
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "목",
    "parentCode": "10700",
    "subjectCode": "10706",
    "subjectName": "인사관리비",
    "abbrName": "인사관리비",
    "finalYn": "N",
    "sortOrder": 1200
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "10706",
    "subjectCode": "1070601",
    "subjectName": "교육지원",
    "abbrName": "교육지원",
    "finalYn": "Y",
    "sortOrder": 1210
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "목",
    "parentCode": "30500",
    "subjectCode": "30500-32102",
    "subjectName": "대외협력사업",
    "abbrName": "대외협력사업",
    "finalYn": "N",
    "sortOrder": 1220
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "30500-32102",
    "subjectCode": "30500-3210201",
    "subjectName": "대외협력사업비",
    "abbrName": "대외협력사업비",
    "finalYn": "Y",
    "sortOrder": 1230
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "33101",
    "subjectCode": "3310101",
    "subjectName": "사업평가",
    "abbrName": "사업평가",
    "finalYn": "Y",
    "sortOrder": 1240
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "목",
    "parentCode": "30500",
    "subjectCode": "32101",
    "subjectName": "지부지원사업",
    "abbrName": "지부지원사업",
    "finalYn": "N",
    "sortOrder": 1250
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "32101",
    "subjectCode": "3210103",
    "subjectName": "사업장방문",
    "abbrName": "사업장방문",
    "finalYn": "Y",
    "sortOrder": 1260
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "목",
    "parentCode": "30100",
    "subjectCode": "30100-33101",
    "subjectName": "기획사업비",
    "abbrName": "기획사업비",
    "finalYn": "N",
    "sortOrder": 1270
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "30100-33101",
    "subjectCode": "30100-3310105",
    "subjectName": "기타지부지원사업비",
    "abbrName": "기타지부지원사업",
    "finalYn": "Y",
    "sortOrder": 1280
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "33101",
    "subjectCode": "3310103",
    "subjectName": "사업연구",
    "abbrName": "사업연구",
    "finalYn": "Y",
    "sortOrder": 1290
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "목",
    "parentCode": "30100",
    "subjectCode": "30100-10101",
    "subjectName": "급여",
    "abbrName": "급여",
    "finalYn": "N",
    "sortOrder": 1300
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "30100-10101",
    "subjectCode": "30100-1010103",
    "subjectName": "급여(본부)",
    "abbrName": "급여(본부)",
    "finalYn": "Y",
    "sortOrder": 1310
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "목",
    "parentCode": "30100",
    "subjectCode": "30100-33102",
    "subjectName": "부서운영비",
    "abbrName": "부서운영비",
    "finalYn": "N",
    "sortOrder": 1320
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "30100-33102",
    "subjectCode": "30100-3310201",
    "subjectName": "부서운영비",
    "abbrName": "부서운영비",
    "finalYn": "Y",
    "sortOrder": 1330
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "목",
    "parentCode": "30100",
    "subjectCode": "32202",
    "subjectName": "직원지원정책",
    "abbrName": "직원지원정책",
    "finalYn": "N",
    "sortOrder": 1340
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "32202",
    "subjectCode": "3220204",
    "subjectName": "조직문화",
    "abbrName": "조직문화",
    "finalYn": "Y",
    "sortOrder": 1350
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "32202",
    "subjectCode": "3220203",
    "subjectName": "직원영성훈련",
    "abbrName": "직원영성훈련",
    "finalYn": "Y",
    "sortOrder": 1360
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "목",
    "parentCode": "30100",
    "subjectCode": "32201",
    "subjectName": "정책세미나",
    "abbrName": "정책세미나",
    "finalYn": "N",
    "sortOrder": 1370
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "32201",
    "subjectCode": "3220104",
    "subjectName": "신입직원 세미나",
    "abbrName": "신입직원 세미나",
    "finalYn": "Y",
    "sortOrder": 1380
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "32201",
    "subjectCode": "3220103",
    "subjectName": "직원 세미나",
    "abbrName": "직원 세미나",
    "finalYn": "Y",
    "sortOrder": 1390
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "32201",
    "subjectCode": "3220102",
    "subjectName": "리더 세미나",
    "abbrName": "리더 세미나",
    "finalYn": "Y",
    "sortOrder": 1400
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "32201",
    "subjectCode": "3220101",
    "subjectName": "전담직 세미나",
    "abbrName": "전담직 세미나",
    "finalYn": "Y",
    "sortOrder": 1410
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "목",
    "parentCode": "30500",
    "subjectCode": "30701",
    "subjectName": "역량강화사업",
    "abbrName": "역량강화사업",
    "finalYn": "N",
    "sortOrder": 1420
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "30701",
    "subjectCode": "3070102",
    "subjectName": "진로탐색지원",
    "abbrName": "진로탐색지원",
    "finalYn": "Y",
    "sortOrder": 1430
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "40105",
    "subjectCode": "4010501",
    "subjectName": "지역아동센터 전출금(후원금)",
    "abbrName": "지역아동센터 전",
    "finalYn": "Y",
    "sortOrder": 1440
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "30701",
    "subjectCode": "3070101",
    "subjectName": "교육지원사업",
    "abbrName": "교육지원사업",
    "finalYn": "Y",
    "sortOrder": 1450
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "목",
    "parentCode": "40100",
    "subjectCode": "40103",
    "subjectName": "아동보호전문기관 전출금(후원금)",
    "abbrName": "아동보호전문기관",
    "finalYn": "N",
    "sortOrder": 1460
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "40103",
    "subjectCode": "4010301",
    "subjectName": "아동보호전문기관 전출금(후원금)",
    "abbrName": "아동보호전문기관",
    "finalYn": "Y",
    "sortOrder": 1470
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "목",
    "parentCode": "30500",
    "subjectCode": "30702",
    "subjectName": "협력시설지원",
    "abbrName": "협력시설지원",
    "finalYn": "N",
    "sortOrder": 1480
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "30702",
    "subjectCode": "3070202",
    "subjectName": "기타지원사업",
    "abbrName": "기타지원사업",
    "finalYn": "Y",
    "sortOrder": 1490
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "30702",
    "subjectCode": "3070201",
    "subjectName": "운영지원사업",
    "abbrName": "운영지원사업",
    "finalYn": "Y",
    "sortOrder": 1500
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "40110",
    "subjectCode": "4011002",
    "subjectName": "가정위탁지원센터 전출금(후원금)기타",
    "abbrName": "가정위탁지원센터",
    "finalYn": "Y",
    "sortOrder": 1510
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "목",
    "parentCode": "30500",
    "subjectCode": "30705",
    "subjectName": "미래성장 지원 기획사업비",
    "abbrName": "미래성장 지원 ",
    "finalYn": "N",
    "sortOrder": 1520
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "30705",
    "subjectCode": "3070501",
    "subjectName": "미래성장 지원 기획사업",
    "abbrName": "미래성장 지원 ",
    "finalYn": "Y",
    "sortOrder": 1530
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "목",
    "parentCode": "30500",
    "subjectCode": "30802",
    "subjectName": "자립 지원 기획사업비",
    "abbrName": "자립 지원 기획",
    "finalYn": "N",
    "sortOrder": 1540
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "30802",
    "subjectCode": "3080201",
    "subjectName": "자립 지원 기획사업",
    "abbrName": "자립 지원 기획",
    "finalYn": "Y",
    "sortOrder": 1550
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "30801",
    "subjectCode": "3080102",
    "subjectName": "자립생활",
    "abbrName": "자립생활",
    "finalYn": "Y",
    "sortOrder": 1560
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "40108",
    "subjectCode": "4010802",
    "subjectName": "자립지원전담기관 전출금(후원금)기타",
    "abbrName": "자립지원전담기관",
    "finalYn": "Y",
    "sortOrder": 1570
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "목",
    "parentCode": "30500",
    "subjectCode": "30404",
    "subjectName": "건강증진지원사업",
    "abbrName": "건강증진지원사업",
    "finalYn": "N",
    "sortOrder": 1580
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "30404",
    "subjectCode": "3040401",
    "subjectName": "건강관리지원",
    "abbrName": "건강관리지원",
    "finalYn": "Y",
    "sortOrder": 1590
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "목",
    "parentCode": "30500",
    "subjectCode": "30407",
    "subjectName": "신체건강 지원 기획사업비",
    "abbrName": "신체건강 지원 ",
    "finalYn": "N",
    "sortOrder": 1600
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "30407",
    "subjectCode": "3040701",
    "subjectName": "신체건강 지원 기획사업",
    "abbrName": "신체건강 지원 ",
    "finalYn": "Y",
    "sortOrder": 1610
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "40103",
    "subjectCode": "4010302",
    "subjectName": "아동보호전문기관 전출금(후원금)기타",
    "abbrName": "아동보호전문기관",
    "finalYn": "Y",
    "sortOrder": 1620
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "목",
    "parentCode": "30500",
    "subjectCode": "30301",
    "subjectName": "긴급 위기사례 지원사업",
    "abbrName": "긴급 위기사례 ",
    "finalYn": "N",
    "sortOrder": 1630
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "30301",
    "subjectCode": "3030101",
    "subjectName": "생계비지원",
    "abbrName": "생계비지원",
    "finalYn": "Y",
    "sortOrder": 1640
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "30100-33102",
    "subjectCode": "30100-3310202",
    "subjectName": "업무추진비",
    "abbrName": "업무추진비",
    "finalYn": "Y",
    "sortOrder": 1650
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "목",
    "parentCode": "10100",
    "subjectCode": "10104",
    "subjectName": "퇴직금 및 퇴직적립금",
    "abbrName": "퇴직금 및 퇴직",
    "finalYn": "N",
    "sortOrder": 1660
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "10104",
    "subjectCode": "1010403",
    "subjectName": "퇴직금 및 퇴직적립금(본부)",
    "abbrName": "퇴직금 및 퇴직",
    "finalYn": "Y",
    "sortOrder": 1670
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "목",
    "parentCode": "30500",
    "subjectCode": "31105",
    "subjectName": "사회적 약자 지원",
    "abbrName": "사회적 약자 지",
    "finalYn": "N",
    "sortOrder": 1680
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "31105",
    "subjectCode": "3110501",
    "subjectName": "사회적 약자 지원 서비스",
    "abbrName": "사회적 약자 지",
    "finalYn": "Y",
    "sortOrder": 1690
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "목",
    "parentCode": "10700",
    "subjectCode": "10708",
    "subjectName": "제세공과금",
    "abbrName": "제세공과금",
    "finalYn": "N",
    "sortOrder": 1700
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "10708",
    "subjectCode": "1070803",
    "subjectName": "제세공과금(본부)",
    "abbrName": "제세공과금(본부",
    "finalYn": "Y",
    "sortOrder": 1710
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "목",
    "parentCode": "10600",
    "subjectCode": "10601",
    "subjectName": "기관운영비",
    "abbrName": "기관운영비",
    "finalYn": "N",
    "sortOrder": 1720
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "10601",
    "subjectCode": "1060101",
    "subjectName": "기관운영비",
    "abbrName": "기관운영비",
    "finalYn": "Y",
    "sortOrder": 1730
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "32101",
    "subjectCode": "3210105",
    "subjectName": "조직관리",
    "abbrName": "조직관리",
    "finalYn": "Y",
    "sortOrder": 1740
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "32202",
    "subjectCode": "3220201",
    "subjectName": "장기근속포상",
    "abbrName": "장기근속포상",
    "finalYn": "Y",
    "sortOrder": 1750
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "32202",
    "subjectCode": "3220202",
    "subjectName": "기타복지지원",
    "abbrName": "기타복지지원",
    "finalYn": "Y",
    "sortOrder": 1760
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "10706",
    "subjectCode": "1070602",
    "subjectName": "인사관리",
    "abbrName": "인사관리",
    "finalYn": "Y",
    "sortOrder": 1770
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "목",
    "parentCode": "30100",
    "subjectCode": "30100-32101",
    "subjectName": "지부지원사업",
    "abbrName": "지부지원사업",
    "finalYn": "N",
    "sortOrder": 1780
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "30100-32101",
    "subjectCode": "3210104",
    "subjectName": "사업연구",
    "abbrName": "사업연구",
    "finalYn": "Y",
    "sortOrder": 1790
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "목",
    "parentCode": "10700",
    "subjectCode": "10709",
    "subjectName": "보험료",
    "abbrName": "보험료",
    "finalYn": "N",
    "sortOrder": 1800
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "10709",
    "subjectCode": "1070901",
    "subjectName": "보험료(본부)",
    "abbrName": "보험료(본부)",
    "finalYn": "Y",
    "sortOrder": 1810
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "목",
    "parentCode": "10100",
    "subjectCode": "10105",
    "subjectName": "사회보험 부담금",
    "abbrName": "사회보험 부담금",
    "finalYn": "N",
    "sortOrder": 1820
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "10105",
    "subjectCode": "1010500",
    "subjectName": "사회보험부담금(정규직/기간제)",
    "abbrName": "사회보험부담금(",
    "finalYn": "Y",
    "sortOrder": 1830
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "32101",
    "subjectCode": "3210102",
    "subjectName": "사업평가",
    "abbrName": "사업평가",
    "finalYn": "Y",
    "sortOrder": 1840
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "32101",
    "subjectCode": "3210101",
    "subjectName": "사업계획",
    "abbrName": "사업계획",
    "finalYn": "Y",
    "sortOrder": 1850
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "31002",
    "subjectCode": "3100201",
    "subjectName": "홍보사업",
    "abbrName": "홍보사업",
    "finalYn": "Y",
    "sortOrder": 1860
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "목",
    "parentCode": "30100",
    "subjectCode": "32203",
    "subjectName": "정책연구사업",
    "abbrName": "정책연구사업",
    "finalYn": "N",
    "sortOrder": 1870
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "32203",
    "subjectCode": "3220301",
    "subjectName": "사업정책연구",
    "abbrName": "사업정책연구",
    "finalYn": "Y",
    "sortOrder": 1880
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "목",
    "parentCode": "30500",
    "subjectCode": "30103",
    "subjectName": "학대피해아동보호 및 예방 기획사업비",
    "abbrName": "학대피해아동보호",
    "finalYn": "N",
    "sortOrder": 1890
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "30103",
    "subjectCode": "3010301",
    "subjectName": "학대피해아동보호 및 예방 기획사업",
    "abbrName": "학대피해아동보호",
    "finalYn": "Y",
    "sortOrder": 1900
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "30601",
    "subjectCode": "3060101",
    "subjectName": "주거환경개선",
    "abbrName": "주거환경개선",
    "finalYn": "Y",
    "sortOrder": 1910
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "목",
    "parentCode": "30500",
    "subjectCode": "30101",
    "subjectName": "아동학대사례관리",
    "abbrName": "아동학대사례관리",
    "finalYn": "N",
    "sortOrder": 1920
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "30101",
    "subjectCode": "3010102",
    "subjectName": "아동학대사례관리",
    "abbrName": "아동학대사례관리",
    "finalYn": "Y",
    "sortOrder": 1930
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "32301",
    "subjectCode": "3230112",
    "subjectName": "지역사회개발",
    "abbrName": "지역사회개발",
    "finalYn": "Y",
    "sortOrder": 1940
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "33101",
    "subjectCode": "3310102",
    "subjectName": "사업장방문",
    "abbrName": "사업장방문",
    "finalYn": "Y",
    "sortOrder": 1950
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "30100-33102",
    "subjectCode": "3310203",
    "subjectName": "장비유지보수비",
    "abbrName": "장비유지보수비",
    "finalYn": "Y",
    "sortOrder": 1960
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "33102",
    "subjectCode": "30500-3310203",
    "subjectName": "장비유지보수비",
    "abbrName": "장비유지보수비",
    "finalYn": "Y",
    "sortOrder": 1970
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "목",
    "parentCode": "40100",
    "subjectCode": "40106",
    "subjectName": "어린이집 전출금(후원금)",
    "abbrName": "어린이집 전출금",
    "finalYn": "N",
    "sortOrder": 1980
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "40106",
    "subjectCode": "4010601",
    "subjectName": "어린이집 전출금(후원금)",
    "abbrName": "어린이집 전출금",
    "finalYn": "Y",
    "sortOrder": 1990
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "10714",
    "subjectCode": "1071404",
    "subjectName": "기타제지출(기타)",
    "abbrName": "기타제지출(기타",
    "finalYn": "Y",
    "sortOrder": 2000
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "10714",
    "subjectCode": "1071402",
    "subjectName": "기타제지출(부서운영비)",
    "abbrName": "기타제지출(부서",
    "finalYn": "Y",
    "sortOrder": 2010
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "목",
    "parentCode": "10700",
    "subjectCode": "10712",
    "subjectName": "사무실관리비",
    "abbrName": "사무실관리비",
    "finalYn": "N",
    "sortOrder": 2020
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "10712",
    "subjectCode": "1071202",
    "subjectName": "사무실관리비",
    "abbrName": "사무실관리비",
    "finalYn": "Y",
    "sortOrder": 2030
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "10712",
    "subjectCode": "1071201",
    "subjectName": "임대료",
    "abbrName": "임대료",
    "finalYn": "Y",
    "sortOrder": 2040
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "목",
    "parentCode": "10700",
    "subjectCode": "10710",
    "subjectName": "차량비",
    "abbrName": "차량비",
    "finalYn": "N",
    "sortOrder": 2050
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "10710",
    "subjectCode": "1071003",
    "subjectName": "차량렌트비",
    "abbrName": "차량렌트비",
    "finalYn": "Y",
    "sortOrder": 2060
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "10710",
    "subjectCode": "1071002",
    "subjectName": "차량유지보수비",
    "abbrName": "차량유지보수비",
    "finalYn": "Y",
    "sortOrder": 2070
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "10710",
    "subjectCode": "1071001",
    "subjectName": "차량유류대",
    "abbrName": "차량유류대",
    "finalYn": "Y",
    "sortOrder": 2080
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "목",
    "parentCode": "10700",
    "subjectCode": "10704",
    "subjectName": "사무용품비",
    "abbrName": "사무용품비",
    "finalYn": "N",
    "sortOrder": 2090
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "10704",
    "subjectCode": "1070401",
    "subjectName": "사무용품비(본부)",
    "abbrName": "사무용품비(본부",
    "finalYn": "Y",
    "sortOrder": 2100
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "10701",
    "subjectCode": "1070102",
    "subjectName": "여비교통비(본부)",
    "abbrName": "여비교통비(본부",
    "finalYn": "Y",
    "sortOrder": 2110
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "목",
    "parentCode": "10600",
    "subjectCode": "10603",
    "subjectName": "회의비",
    "abbrName": "회의비",
    "finalYn": "N",
    "sortOrder": 2120
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "10603",
    "subjectCode": "1060301",
    "subjectName": "회의비",
    "abbrName": "회의비",
    "finalYn": "Y",
    "sortOrder": 2130
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "목",
    "parentCode": "10600",
    "subjectCode": "10602",
    "subjectName": "직책보조비",
    "abbrName": "직책보조비",
    "finalYn": "N",
    "sortOrder": 2140
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "10602",
    "subjectCode": "1060201",
    "subjectName": "직책보조비",
    "abbrName": "직책보조비",
    "finalYn": "Y",
    "sortOrder": 2150
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "32301",
    "subjectCode": "3230102",
    "subjectName": "회비수수료",
    "abbrName": "회비수수료",
    "finalYn": "Y",
    "sortOrder": 2160
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "10714",
    "subjectCode": "1071403",
    "subjectName": "기타제지출(회계교육)",
    "abbrName": "기타제지출(회계",
    "finalYn": "Y",
    "sortOrder": 2170
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "목",
    "parentCode": "30500",
    "subjectCode": "31118",
    "subjectName": "지역사회 지원(물품)",
    "abbrName": "지역사회 지원(",
    "finalYn": "N",
    "sortOrder": 2180
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "31118",
    "subjectCode": "3111801",
    "subjectName": "지역사회 지원(물품)",
    "abbrName": "지역사회 지원(",
    "finalYn": "Y",
    "sortOrder": 2190
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "30100-32101",
    "subjectCode": "30100-3210103",
    "subjectName": "사업장방문",
    "abbrName": "사업장방문",
    "finalYn": "Y",
    "sortOrder": 2200
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "목",
    "parentCode": "30500",
    "subjectCode": "30500-32202",
    "subjectName": "직원지원정책",
    "abbrName": "직원지원정책",
    "finalYn": "N",
    "sortOrder": 2210
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑)",
    "levelName": "세목",
    "parentCode": "30500-32202",
    "subjectCode": "3220206",
    "subjectName": "정책연구사업지원인력",
    "abbrName": "정책연구사업지원",
    "finalYn": "Y",
    "sortOrder": 2220
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑) · 세항 단독(목·세목 자동생성)",
    "levelName": "목",
    "parentCode": "10200",
    "subjectCode": "10201",
    "subjectName": "원장인건비",
    "abbrName": "원장인건비",
    "finalYn": "N",
    "sortOrder": 2230
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑) · 세항 단독(목·세목 자동생성)",
    "levelName": "세목",
    "parentCode": "10201",
    "subjectCode": "1020001",
    "subjectName": "원장인건비",
    "abbrName": "원장인건비",
    "finalYn": "Y",
    "sortOrder": 2240
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑) · 세항 단독(목·세목 자동생성)",
    "levelName": "목",
    "parentCode": "10300",
    "subjectCode": "10301",
    "subjectName": "보육교직원인건비",
    "abbrName": "보육교직원인건비",
    "finalYn": "N",
    "sortOrder": 2250
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑) · 세항 단독(목·세목 자동생성)",
    "levelName": "세목",
    "parentCode": "10301",
    "subjectCode": "1030001",
    "subjectName": "보육교직원인건비",
    "abbrName": "보육교직원인건비",
    "finalYn": "Y",
    "sortOrder": 2260
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑) · 세항 단독(목·세목 자동생성)",
    "levelName": "목",
    "parentCode": "10400",
    "subjectCode": "10401",
    "subjectName": "기타인건비",
    "abbrName": "기타인건비",
    "finalYn": "N",
    "sortOrder": 2270
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑) · 세항 단독(목·세목 자동생성)",
    "levelName": "세목",
    "parentCode": "10401",
    "subjectCode": "1040001",
    "subjectName": "기타인건비",
    "abbrName": "기타인건비",
    "finalYn": "Y",
    "sortOrder": 2280
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑) · 세항 단독(목·세목 자동생성)",
    "levelName": "목",
    "parentCode": "10500",
    "subjectCode": "10501",
    "subjectName": "기관부담금",
    "abbrName": "기관부담금",
    "finalYn": "N",
    "sortOrder": 2290
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑) · 세항 단독(목·세목 자동생성)",
    "levelName": "세목",
    "parentCode": "10501",
    "subjectCode": "1050001",
    "subjectName": "기관부담금",
    "abbrName": "기관부담금",
    "finalYn": "Y",
    "sortOrder": 2300
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑) · 세항 단독(목·세목 자동생성)",
    "levelName": "목",
    "parentCode": "30601",
    "subjectCode": "30601-30601",
    "subjectName": "운영비(시설)",
    "abbrName": "운영비(시설)",
    "finalYn": "N",
    "sortOrder": 2310
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑) · 세항 단독(목·세목 자동생성)",
    "levelName": "세목",
    "parentCode": "30601-30601",
    "subjectCode": "30601-3060101",
    "subjectName": "운영비(시설)",
    "abbrName": "운영비(시설)",
    "finalYn": "Y",
    "sortOrder": 2320
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑) · 세항 단독(목·세목 자동생성)",
    "levelName": "목",
    "parentCode": "30200",
    "subjectCode": "30201",
    "subjectName": "교육비",
    "abbrName": "교육비",
    "finalYn": "N",
    "sortOrder": 2330
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑) · 세항 단독(목·세목 자동생성)",
    "levelName": "세목",
    "parentCode": "30201",
    "subjectCode": "3020001",
    "subjectName": "교육비",
    "abbrName": "교육비",
    "finalYn": "Y",
    "sortOrder": 2340
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑) · 세항 단독(목·세목 자동생성)",
    "levelName": "목",
    "parentCode": "30300",
    "subjectCode": "30300-30301",
    "subjectName": "기본보육활동",
    "abbrName": "기본보육활동",
    "finalYn": "N",
    "sortOrder": 2350
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑) · 세항 단독(목·세목 자동생성)",
    "levelName": "세목",
    "parentCode": "30300-30301",
    "subjectCode": "3030001",
    "subjectName": "기본보육활동",
    "abbrName": "기본보육활동",
    "finalYn": "Y",
    "sortOrder": 2360
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑) · 세항 단독(목·세목 자동생성)",
    "levelName": "목",
    "parentCode": "30400",
    "subjectCode": "30401",
    "subjectName": "수익자부담경비",
    "abbrName": "수익자부담경비",
    "finalYn": "N",
    "sortOrder": 2370
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑) · 세항 단독(목·세목 자동생성)",
    "levelName": "세목",
    "parentCode": "30401",
    "subjectCode": "3040001",
    "subjectName": "수익자부담경비",
    "abbrName": "수익자부담경비",
    "finalYn": "Y",
    "sortOrder": 2380
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑) · 세항 단독(목·세목 자동생성)",
    "levelName": "목",
    "parentCode": "70100",
    "subjectCode": "70101",
    "subjectName": "잡지출",
    "abbrName": "잡지출",
    "finalYn": "N",
    "sortOrder": 2390
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑) · 세항 단독(목·세목 자동생성)",
    "levelName": "세목",
    "parentCode": "70101",
    "subjectCode": "7010001",
    "subjectName": "잡지출",
    "abbrName": "잡지출",
    "finalYn": "Y",
    "sortOrder": 2400
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑) · 세항 단독(목·세목 자동생성)",
    "levelName": "목",
    "parentCode": "50100",
    "subjectCode": "50101",
    "subjectName": "과년도지출",
    "abbrName": "과년도지출",
    "finalYn": "N",
    "sortOrder": 2410
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑) · 세항 단독(목·세목 자동생성)",
    "levelName": "세목",
    "parentCode": "50101",
    "subjectCode": "5010001",
    "subjectName": "과년도지출",
    "abbrName": "과년도지출",
    "finalYn": "Y",
    "sortOrder": 2420
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑) · 세항 단독(목·세목 자동생성)",
    "levelName": "목",
    "parentCode": "60100",
    "subjectCode": "60101",
    "subjectName": "상환금",
    "abbrName": "상환금",
    "finalYn": "N",
    "sortOrder": 2430
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑) · 세항 단독(목·세목 자동생성)",
    "levelName": "세목",
    "parentCode": "60101",
    "subjectCode": "6010001",
    "subjectName": "상환금",
    "abbrName": "상환금",
    "finalYn": "Y",
    "sortOrder": 2440
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑) · 세항 단독(목·세목 자동생성)",
    "levelName": "세목",
    "parentCode": "60201",
    "subjectCode": "6020101",
    "subjectName": "부채상환금",
    "abbrName": "부채상환금",
    "finalYn": "Y",
    "sortOrder": 2450
  },
  {
    "useYn": "Y",
    "eNaraDoum": "",
    "funcDiv": "",
    "natureDiv": "",
    "fundUid": "",
    "budgetType": "사업예산",
    "remark": "GNK 예산과목 (관-항-세항 + 세항-목-세목 매핑) · 세항 단독(목·세목 자동생성)",
    "levelName": "세목",
    "parentCode": "80101",
    "subjectCode": "8010101",
    "subjectName": "반환금",
    "abbrName": "반환금",
    "finalYn": "Y",
    "sortOrder": 2460
  }
];
